import type { AxisSeriesSettings } from './types';
import {
  BY_METRIC_LINE_WIDTH,
  DEFAULT_LEFT_AXIS_SERIES,
  DEFAULT_LINE_WIDTH,
  DEFAULT_RIGHT_AXIS_SERIES,
} from './types';

interface AxisSeriesHolder {
  leftAxisSeries?: AxisSeriesSettings;
  rightAxisSeries?: AxisSeriesSettings;
}

const healAxisSeries = (
  series: AxisSeriesSettings | undefined,
  catalogMetrics: Set<string>,
  fallback: AxisSeriesSettings,
): AxisSeriesSettings => {
  const current = series ?? { ...fallback };

  if (current.lineWidthMetric && catalogMetrics.has(current.lineWidthMetric)) {
    return current;
  }

  if (!current.lineWidthMetric && current.lineWidth !== BY_METRIC_LINE_WIDTH) {
    return current;
  }

  return {
    ...current,
    lineWidthMetric: '',
    lineWidth:
      current.lineWidth === BY_METRIC_LINE_WIDTH
        ? DEFAULT_LINE_WIDTH
        : current.lineWidth,
  };
};

export const getHealedAxes = (
  chart: AxisSeriesHolder,
  catalogMetrics: Set<string>,
) => {
  return {
    leftAxisSeries: healAxisSeries(
      chart.leftAxisSeries,
      catalogMetrics,
      DEFAULT_LEFT_AXIS_SERIES,
    ),
    rightAxisSeries: healAxisSeries(
      chart.rightAxisSeries,
      catalogMetrics,
      DEFAULT_RIGHT_AXIS_SERIES,
    ),
  };
};
